var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.chunkedOrderedYearMonths, function (threeMonths, i) {
        return [
          _c(
            "div",
            {
              key: i,
              staticClass: "boss-calendar-row",
              attrs: { "data-test": "months-" + i },
            },
            [
              _vm._l(threeMonths, function (month, j) {
                return [
                  _c(
                    "div",
                    {
                      key: i + "-" + j,
                      staticClass: "boss-calendar-one-month",
                    },
                    [
                      _c("interview-candidate-date-calendar-month", {
                        key: i + "-" + j,
                        attrs: {
                          "target-year": month.year,
                          "target-month": month.month,
                          schedule: _vm.schedule,
                          candidates: _vm.candidates,
                        },
                        on: { changeNgDateCalendar: _vm.changeNgDate },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }